import { render, staticRenderFns } from "./olga.vue?vue&type=template&id=5ff62736&scoped=true&lang=html&"
import script from "./olga.vue?vue&type=script&lang=js&"
export * from "./olga.vue?vue&type=script&lang=js&"
import style0 from "./olga.vue?vue&type=style&index=0&id=5ff62736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff62736",
  null
  
)

export default component.exports